// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2eBIM","productName":"Table_productName__3Zi0D"};